import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import HistorizationBannerViewModelType from '@/ViewModels/Controls/HistorizationBannerViewModel';
import LabelType from '@/Controls/Label';

export default class HistorizationBanner extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private jQueryControl: JQuery;
    private label: LabelType;

    public constructor(private viewModel: HistorizationBannerViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        //CF-2317: leeres hidden-input damit dieses in der DV fokusiert werden kann und der scrollbereich nicht verschoben wird
        this.jQueryControl = this.element || $('<div><input type="hidden" tabindex="0"></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'historizationbanner',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            invalid: this.viewModel.invalidationText,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('HistorizationBanner', HistorizationBanner, 'RADPresentation.HTMLClient.DefaultViewExtensions');